(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle").off("click").click(function () {
      if (!$(this).hasClass("active")) { $(this).addClass("active"); $(this).siblings(".about__accordion-description").eq($(this).index()).stop().slideDown(300); }
      else { $(this).removeClass("active"); $(this).siblings(".about__accordion-description").stop().slideUp(300); }
    });
  };
  const initCustomCursor = () => {
    let cursor = document.querySelector(".product-zoom-cursor");
    if (!cursor) { cursor = document.createElement("div"); cursor.className = "product-zoom-cursor"; document.body.appendChild(cursor); }
    cursor.classList.remove("active");
    const zoomTriggers = document.querySelectorAll(".product__media-toggle, .product-media-modal__content");
    const moveCursor = (e) => { cursor.style.left = e.clientX - 24 + "px"; cursor.style.top = e.clientY - 24 + "px"; };
    zoomTriggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", () => { cursor.classList.add("active"); document.removeEventListener("mousemove", moveCursor); document.addEventListener("mousemove", moveCursor); });
      trigger.addEventListener("mouseleave", () => { cursor.classList.remove("active"); document.removeEventListener("mousemove", moveCursor); });
    });
  };
  const initZoomImage = () => {
    const imagesWrapper = document.querySelector(".product-media-modal__content"); if (!imagesWrapper) return;
    imagesWrapper.querySelectorAll(".js-image-zoom").forEach((el) => el.addEventListener("click", () => imagesWrapper.classList.toggle("zoom")));
  };
  const revealPopup = () => {
    const stickyBar = document.querySelector(".product__popup"), secondSection = document.querySelector(".product-section + section"), footer = document.querySelector("footer");
    if (!stickyBar || !secondSection || !footer) return;
    const getOffset = (element) => element.getBoundingClientRect().top + window.scrollY;
    const secondSectionMid = getOffset(secondSection), footerTop = getOffset(footer);
    const handleScroll = () => { const scrollPosition = window.scrollY + window.innerHeight; const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop; stickyBar.classList[activeOffset ? "add" : "remove"]("active"); };
    handleScroll();
  };
  window.reinitProductUI = () => { initProductAccordion(); initZoomImage(); initCustomCursor(); revealPopup(); };
  document.addEventListener("scroll", () => revealPopup());
  document.addEventListener("shopify:section:load", () => window.reinitProductUI());
  window.reinitProductUI();
})();

class FloatedForm extends HTMLElement {
  constructor() { super(); this.renderForm(); }
  renderForm() {
    fetch(this.getAttribute("data-product-url"))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
        this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]');
        this.preventDuplicatedIDs(); this.removeDOMElements(); this.setInnerHTML(this, this.productElement.innerHTML);
        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
        this.showMoreFields();
      })
      .finally(() => {
        const selectDropDown = () => {
          $(".product__popup .product-form__controls--dropdown").each(function () {
            const elListItem = $(this).find(".dropdown-select ul li"), elItem = $(this).find(".dropdown-select ul"), selectedText = $(this).find(".dropdown-select .select-label");
            selectedText.on("click", function (e) { elItem.toggleClass("active"); if (elItem.hasClass("active")) { e.stopPropagation(); $(document).click(() => elItem.removeClass("active")); } });
            elListItem.on("click", function () { selectedText.find("span").text($(this).text()).attr("title", $(this).text()); elItem.removeClass("active"); document.activeElement.blur(); });
          });
        };
        selectDropDown();
      });
  }
  setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => { const newScriptTag = document.createElement("script"); Array.from(oldScriptTag.attributes).forEach((attribute) => newScriptTag.setAttribute(attribute.name, attribute.value)); newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML)); oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag); });
  }
  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `floated-${sectionId}`);
    this.productElement.querySelectorAll("variant-selects").forEach((radio) => { radio.dataset.originalSection = sectionId; });
    this.productElement.querySelectorAll("variant-radios").forEach((radio) => { radio.dataset.originalSection = sectionId; });
  }
  removeDOMElements() {
    [".product__text", ".product__tags", ".product__title__wrapper", ".product__custom-badges", ".price-wrapper", ".product__description", ".product__sku", ".product__inventory", "pickup-availability", ".custom-liquid", "product-recommendations", ".share-buttons", ".product-popup"].forEach((selector) => this.productElement.querySelectorAll(selector).forEach((el) => el.remove()));
    const productForm = this.productElement.querySelector("floated-form"); if (productForm) productForm.remove();
  }
  showMoreFields() { $(".js-show-more").click(function (e) { e.preventDefault(); $(this).siblings("input").removeClass("hidden"); $(this).siblings("label").removeClass("hidden"); $(this).remove(); }); }
}
customElements.define("floated-form", FloatedForm);

/* McQueen Boutique: hide the BCPO "Customize the Size?" option only when the current product is actually in The Ready Edit. */
(function () {
  const hideReadyEditCustomSize = () => {
    if (!location.pathname.includes("/products/")) return;
    const handle = location.pathname.split("/products/")[1]?.split("/")[0];
    if (!handle) return;
    fetch("/collections/the-ready-edit/products.json?limit=250", { credentials: "same-origin" })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        const isReadyEditProduct = Array.isArray(data?.products) && data.products.some((product) => product.handle === handle);
        if (!isReadyEditProduct) return;
        const hideOption = () => document.querySelectorAll("label").forEach((label) => { if (label.textContent.trim() === "Customize the Size?") label.style.display = "none"; });
        hideOption();
        const observer = new MutationObserver(hideOption);
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), 15000);
      })
      .catch(() => {});
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", hideReadyEditCustomSize); else hideReadyEditCustomSize();
})();
